<template>
  <div class="media-avatar">
    <v-avatar :size="size" :tile="tile" class="rounded-lg">
      <img :src="thumbSrc" alt="avatar" />
    </v-avatar>

    <v-btn
      class="media-avatar__delete-btn"
      color="error"
      fab
      x-small
      dark
      @click="removeMedia(media.id)"
      v-if="deleteMedia"
    >
      <v-icon>{{ icons.delete }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mdiTrashCanOutline } from '@mdi/js'

export default {
  props: {
    media: {
      default: []
    },
    alt: {
      type: String,
      default: 'Avatar'
    },
    size: {
      type: String,
      default: '120'
    },
    tile: {
      type: Boolean
    },
    deleteMedia: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      icons: {
        delete: mdiTrashCanOutline
      }
    }
  },

  computed: {
    thumbSrc() {
      return this.media
        ? this.media.url
        : require('@/assets/images/default-profile.png')
    }
  },

  methods: {
    removeMedia(imageId) {
      this.$emit('delete', imageId)
    }
  }
}
</script>

<style lang="scss" scoped>
.media-avatar {
  position: relative;
  max-width: 170px;
  padding-right: 10px;
  padding-top: 10px;

  &__delete-btn {
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
